import { useState } from "react";
import { TableRow, TableCell } from "@mui/material";
import { Stack, Box, Button, Chip, IconButton, styled } from "@mui/material";
import {
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  DialogContent,
} from "@mui/material";
import { ArrowUpward, ArrowDownward, Clear } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { statusMap } from "../InboxPage";
import { EmailItem } from "./EmailItem";

import { format, parseISO } from "date-fns";

import EmailIcon from "@assets/mail.png";
import UploadIcon from "@assets/upload.png";
import MobileSourceIcon from "@assets/mobile.png";

const ICON_SIZE = 22;

const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "12px",
}));

const TextValue = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
}));

const KeyValueRow = ({ label, value, isHeader }) => {
  const gutter = "4px";
  return (
    <tr>
      <td style={{ padding: gutter, paddingRight: "32px" }}>
        <Label>{label}</Label>
      </td>
      <td style={{ padding: gutter }}>
        {isHeader ? (
          <Typography variant="h6" color="#6be1c2">
            {value}
          </Typography>
        ) : (
          <TextValue>{value || "-"}</TextValue>
        )}
      </td>
    </tr>
  );
};

export function EmailRow({ email, expandRow, setExpandRow }) {
  const [selectedEmail, setSelectedEmail] = useState(null);

  const email_id = email["_id"];
  const isUpload = ["upload", "mobile"].includes(email["type"]);

  const iconSrc =
    email["type"] === "mobile"
      ? MobileSourceIcon
      : isUpload
        ? UploadIcon
        : EmailIcon;

  const status_count = Object.entries(email["status_count"] || {}).reduce(
    (acc, [key, count]) => {
      const match = Object.values(statusMap).find((item) => item.key === key);
      const existing = acc.find((item) => item.name === match.name);
      existing ? (existing.count += count) : acc.push({ ...match, count });
      return acc;
    },
    [],
  );

  return (
    <>
      <TableRow>
        <TableCell colSpan={7}>
          <Stack direction={"row"} gap={3}>
            <Box display={"grid"} sx={{ placeItems: "center" }}>
              <IconButton
                onClick={() => setSelectedEmail(email)}
                disabled={isUpload}
              >
                <img
                  src={iconSrc}
                  style={{ height: ICON_SIZE, width: ICON_SIZE }}
                />
              </IconButton>
            </Box>

            <Box style={{ flexGrow: 1 }}>
              <table>
                <tbody>
                  <KeyValueRow
                    label={isUpload ? "Uploaded By" : "From"}
                    value={email["from"]}
                    isHeader
                  />

                  {!isUpload && (
                    <KeyValueRow label="Subject" value={email["subject"]} />
                  )}

                  <KeyValueRow
                    label="Received on"
                    value={format(
                      parseISO(email["receivedDateTime"]),
                      "MMMM do, yyyy   hh:mma",
                    )}
                  />
                </tbody>
              </table>
            </Box>

            {expandRow !== email_id && (
              <Stack gap={1} direction={"row"} alignSelf={"end"}>
                {status_count.map((status) => (
                  <Chip
                    key={status["name"]}
                    label={`${status["name"]}(${status["count"]})`}
                    color={status["color"]}
                  />
                ))}
              </Stack>
            )}
          </Stack>
        </TableCell>
        <TableCell sx={{ p: 0, position: "relative" }}>
          <Button
            variant="contained"
            color="success"
            disableElevation
            disabled={email["files"].length === 0}
            onClick={() =>
              setExpandRow((prev) => (prev === email_id ? null : email_id))
            }
            endIcon={
              expandRow === email_id ? <ArrowUpward /> : <ArrowDownward />
            }
            sx={{
              borderRadius: 0,
              position: "absolute",
              right: 0,
              left: 0,
              top: 0,
              bottom: 0,
            }}
          >
            Files{`(${email["files"].length})`}
          </Button>
        </TableCell>
      </TableRow>

      <Dialog fullScreen open={selectedEmail !== null}>
        <AppBar position="static">
          <Toolbar variant="dense" sx={{ gap: 3, bgcolor: grey[50] }}>
            <IconButton onClick={() => setSelectedEmail(null)}>
              <Clear />
            </IconButton>
            <Typography variant="h6" color={grey[800]}>
              Mail body preview
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <EmailItem email={selectedEmail} />
        </DialogContent>
      </Dialog>
    </>
  );
}
